var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.portalName)?_c('portal-target',{attrs:{"name":_vm.portalName}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }